import createQueryStore from './createQueryStore';

const store = createQueryStore('orderSummary', {
  initialState: {
    items: null,
    total: null
  },
  reducers: {
    setData: (state, action) => {
      state.data = action.payload;
      state.items = action.payload?.filter?.((item) => item.type !== 'total');

      const total = action.payload?.find?.((item) => item.type === 'total');
      const totalAmount = total?.total < 0 ? 0 : total?.total; // in case of discount bug with negative value
      state.total = total ? { ...total, total: totalAmount } : null;
    }
  }
});

export default store.reducer;
export const actions = store.actions;
export const useOrderSummaryStore = store.useStore;
